<template>
    <div>
        <div class="login-container d-flex justify-content-center align-items-center">
            <div>
                <div class="logo mb-4">
                    <img src="@/assets/images/SE_Logo_White_RGB.png" alt="Logo Siemens" class="mx-auto d-block">
                </div>
                <div class="login-form position-relative">
                    <h3 class="login-head position-absolute top mt-4">登录</h3>
                    <Login ref="login"
                           @user-identified="doLogin"
                           :alwaysShowSwitch="true"
                           :showPasswordLoginButton="true"
                    ></Login>
                    <div v-if="currentEnv === 'test'" class="text-center text-info">您正在登录测试环境</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Login from "@/components/em/login/Login";
import emLoginMixin from "@/mixin/em/common/stuffs/login/emLoginMixin";
import {redirectFromLogin} from "@/utils/loginRedirect";

export default {
    name: "emLogin",
    mixins: [emLoginMixin],
    components: {Login},
    beforeRouteEnter(to, from, next) {
        const jwt = localStorage['em_sso_token'];
        if (jwt) {
            redirectFromLogin(jwt);
        } else {
            next()
        }
    },
    data() {
        return {
            cameraOpened: false,
            usingPassword: true,
        }
    },
    computed: {
        currentEnv() {
            return process.env.NODE_ENV;
        },
    },
    methods: {
        doLogin(userId) {
            this.$store.dispatch("api/post", {
                url: this.$store.state.emAclUser.baseModuleUrl + "/sso/login",
                data: {
                    userId: userId
                },
            }).then((response) => {
                const data = response.data
                this.recordLoginInfoAndRedirect(data)
            })
        },
        switchLoginMethod() {
            this.usingPassword = !this.usingPassword
        },
    }
}
</script>

<style scoped>
.login-container {
    height: 100vh;
    background-image: linear-gradient(#8A00E5 50%, #e3e3e3 50%);
}

.login-form {
    padding: 80px 30px 10px;
    z-index: 1;
    background-color: white;
    min-width: 350px;
    min-height: 390px;
    font-weight: 700;
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5%;
}

.login-head {
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
    font-size: 24px;
}

.logo {
    width: 380px;
    height: 150px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
}

.logo img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
}
</style>

<style lang="scss" scoped>
@media (max-width: 767px) {
    .login-form {
        width: 85%;
    }
    .logo {
        width: 70%;
    }
}
</style>
